import React from 'react';
import styles from './SocialButtonsList.scss';
import { IconButton } from '../IconButton/IconButton';
import classNames from 'classnames';
import { emailIcon } from '@justgiving/icons';
import Svg from '@justgiving/svg';

interface EmailShareRoundProps {
  className?: string;
  subject: string;
  body: string;
}

export const EmailShareRound: React.FunctionComponent<EmailShareRoundProps> = ({
  className,
  subject,
  body,
}) => {
  return (
    <IconButton className={`${styles.roundButton} ${className}`}>
      <a
        href={`mailto:?subject=${encodeURIComponent(
          subject,
        )}&body=${encodeURIComponent(body)}`}
        data-qa="email"
      >
        <div className={classNames(styles.iconWrapper, styles.email)}>
          <Svg markup={emailIcon} className={styles.icon} />
        </div>
        Email
      </a>
    </IconButton>
  );
};
